import React from "react";
import {useHeader} from "../../_metronic/layout";
import {useSubheader} from "../../_metronic/layout";
import {useIntl} from "react-intl";
import InvoicesPage from "../modules/Invoices/InvoicesPage";

export function Invoices() {
  const header = useHeader();
  header.setTitle(useIntl().formatMessage({
    id: "invoices-page-title",
    defaultMessage: "Invoices"
  }));
  const subheader = useSubheader();
  subheader.setCustomClassName("subheader-custom-height");
  subheader.setDisplaySubheader(false);

  return <InvoicesPage/>;
}
